// import React from "react";
// import "./YouthSection.css";
// import youthIllustration from "../../assets/img/discount_offers/youth-section.png";
// import youthText from "../../assets/img/discount_offers/youth-offer-text.png";


// const YouthSection = React.forwardRef((props, ref) => {
//   return (
//     <section className="youth-section position-relative mb-5" ref={ref}>

//       {/* Wrapper containing both image + text */}
//       <div className="youth-bg-wrapper">

//         {/* Background Illustration */}
//         <img 
//           src={youthIllustration}
//           alt="Youth Illustration"
//           className="youth-bg"
//         />

//         {/* Overlay Content */}
//         <div className="youth-content text-end">
//           <h2 className="youth-heading">Limitless Ideas of</h2>

//           <h3 className="youth-heading-gradient">Youth</h3>

//           <p className="youth-subtext">
//             <b>Best oCloud offers for students.</b>
//           </p>
//             <div>
//               <img src={youthText} alt="youth title" className="border-0 h-auto w-100" />
//             </div>

//           <button className="btn learn-more-btn">
//             <b>অফার গ্রহণ করুন</b>
//           </button>
//         </div>

//       </div>

//     </section>
//   );
// });

// export default YouthSection;


import React from "react";
import "./YouthSection.css";
import youthIllustration from "../../assets/img/discount_offers/youth-section.png";
// youthText is removed, we will render text directly


const YouthSection = React.forwardRef((props, ref) => {
  return (
    <section className="youth-section position-relative mb-5" ref={ref}>

      {/* Wrapper containing both image + text */}
      <div className="youth-bg-wrapper">

        {/* Background Illustration */}
        <img 
          src={youthIllustration}
          alt="Youth Illustration"
          className="youth-bg"
        />

        {/* Overlay Content */}
        <div className="youth-content text-end">
          <h2 className="youth-heading">Limitless Ideas of</h2>

          <h3 className="youth-heading-gradient">Youth</h3>

          <p className="youth-subtext">
            <b>Best oCloud offers for students.</b>
          </p>
          
          {/* RENDER BENGALI TEXT DIRECTLY FOR RESPONSIVENESS */}
          <p className="offer-taka">১৬ টাকায়</p>
          <p className="offer-storage">১৬ জিবি স্টোরেজ</p>
          <p className="offer-duration">১৬ বছরের জন্য</p>


          <button className="btn hero-offer-btn victory-border" onClick={() => window.location.href = 'https://clients.ocloud.cloud/?cmd=cart&action=add&id=65'}>
            <b>অফার গ্রহণ করুন</b>
          </button>
        </div>

      </div>

    </section>
  );
});

export default YouthSection;